import { render, staticRenderFns } from "./OrderResumeView.vue?vue&type=template&id=cb85f0a2&scoped=true"
import script from "./OrderResumeView.vue?vue&type=script&lang=js"
export * from "./OrderResumeView.vue?vue&type=script&lang=js"
import style0 from "./OrderResumeView.vue?vue&type=style&index=0&id=cb85f0a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb85f0a2",
  null
  
)

export default component.exports